import { createApp } from 'vue';
import store from '../store';
import { registerMaterialSymbol } from './registerMaterialSymbol';

/**
 * Blade “islands” that must stay separate from the main #app shell.
 * Pricing, map teaser, header, and How-it-works teaser are rendered as
 * components inside #app (see Blade). Only the static embed page mounts here.
 *
 * MapPopup is loaded synchronously as the concrete SFC root (not
 * defineAsyncComponent — async roots are unreliable with createApp).
 *
 */
export function mountVueIslands() {
    const mapEmbedEl = document.getElementById('map-embed-app');
    if (!mapEmbedEl) return;

    const imageSrc = mapEmbedEl.getAttribute('data-image-src') || '';
    const caption = mapEmbedEl.getAttribute('data-caption') || '';

    import(/* webpackChunkName: 'map-popup' */ '../components/MapPopup.vue')
        .then(({ default: MapPopupRoot }) => {
            const mapEmbedApp = createApp(MapPopupRoot, { imageSrc, caption, embedOnly: true });
            mapEmbedApp.use(store);
            registerMaterialSymbol(mapEmbedApp);
            mapEmbedApp.mount('#map-embed-app');
        })
        .catch((err) => {
            if (typeof console !== 'undefined' && console.error) {
                console.error('[map-embed] load failed', err);
            }
        });
}
